import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { InitCookie } from '@patsnap/init-cookie';
import { BiTrackService } from '@eureka/domains/src/bi-track/services/bi-track-service';
import { EurekaTrackEventType } from '@eureka/domains/src/bi-track/types';

export interface Channels {
    from?: string
    from_page?: string
    channel_source?: string
    activity_type?: string
    inviter_id?: string
    invitation_code?: string
    anonymousLogin?: boolean
}

export enum EMPOWER_TYPE {
    RD_TRIZ = 'RD_TRIZ',
    RD_FMEA = 'RD_FMEA',
    RD_TECH_RESEARCH = 'RD_TECH_RESEARCH',
    RD_TECH_MIND = 'RD_TECH_MIND'
}

export enum CHANNEL_SOURCE {
    AIR_EUREKA = 'login_eureka_rd_triz'
}

interface RemoteLoginSDK {
    openLoginDialog: (options?: { channels?: Channels; withoutClose?: boolean; onClickRegister?: (method?: string) => void }) => Promise<any>
    initSDK: () => Promise<void>
}

export class LoginSDK {
    private _channels: Channels = {};
    private _remoteSDKPromise: Promise<RemoteLoginSDK> | undefined = undefined;

    private _getRemoteSDK(): Promise<RemoteLoginSDK> {
        this._remoteSDKPromise ??= import(`${import.meta.env.VITE_EUREKA_URI}/login/login.sdk.es.no-cache.js`);
        return this._remoteSDKPromise;
    }

    setChannels(channels: Channels) {
        this._channels = channels;
        return this;
    }

    async open(options?: { withoutClose?: boolean }) {
        const sdk = await this._getRemoteSDK();
        const hashQuery = window.location.hash.split('?')[1] ?? '';
        const urlType = new URLSearchParams(hashQuery).get('type');
        const registrationSource = urlType
            ? (urlType.startsWith('rd') ? urlType : `rd_${urlType}`)
            : this._channels.from_page?.toLowerCase();

        const biTrackService = injectService<BiTrackService>(BiTrackService);
        biTrackService.biTrack(EurekaTrackEventType.SS_PLG_REGISTER, {
            sourceType: 'register_exposure',
            eventDetailStr: JSON.stringify({
                signatureId: InitCookie.getVisitorId(),
                campaignName: InitCookie.getCampaignName(),
                registrationSource,
            }),
        });

        return sdk.openLoginDialog({
            channels: {
                from: 'eureka',
                anonymousLogin: false,
                ...this._channels,
            },
            withoutClose: options?.withoutClose,
            onClickRegister: (method) => {
                biTrackService.biTrack(EurekaTrackEventType.SS_PLG_REGISTER, {
                    sourceType: 'register_click',
                    eventDetailStr: JSON.stringify({
                        signatureId: InitCookie.getVisitorId(),
                        campaignName: InitCookie.getCampaignName(),
                        registrationSource,
                        registrationMethod: method,
                    }),
                });
            },
        });
    }

    handleThirdPartyLoginErrors() {
        // no-op: 第三方登录错误由远程 SDK 处理
    }
}

export const loginSDK = new LoginSDK();
